import React, { useEffect, useRef, useState } from "react";
import {
  useTheme,
  CssBaseline,
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  useMediaQuery,
  Avatar,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import axios from "axios";
import { baseapi } from "../Environmentalurl";
import { useSelector } from "react-redux";
import {
  ApplicationType,
  date,
  entity_id,
  getGeolocation,
  location,
  locationGeo,
  orderID,
  Platform,
} from "../Utils/Const";
import { useNavigate } from "react-router-dom";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function Hospital() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isDark = theme.palette.mode === "dark";
  const md = useMediaQuery("(min-width:900px)");
  const ip = useIPAddress();
  const [operator, setOperator] = useState("");
  const [subscriber, setSubscriber] = useState("");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [operators, setOperators] = useState([]);
  const [selectedOperatorData, setSelectedOperatorData] = useState(null);
  const [dynamicFields, setDynamicFields] = useState([]);
  const [dynamicValues, setDynamicValues] = useState({});
  const [billDetails, setBillDetails] = useState(null);
  const [insufficientMsg, setInsufficientMsg] = useState("");
  const [insufficientOpen, setInsufficientOpen] = useState(false);
  const [openFetchDialog, setOpenFetchDialog] = useState(false);
  const [tpinOpen, setTpinOpen] = useState(false);
  const [tpin, setTpin] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  // ── Charges summary ──────────────────────────────────────────────────────
  const [chargesLoading, setChargesLoading] = useState(false);
  const [chargesData, setChargesData] = useState(null);
  const [chargesOpen, setChargesOpen] = useState(false);

  // ── Payment result dialog ────────────────────────────────────────────────
  const [paymentResult, setPaymentResult] = useState({
    open: false,
    success: false,
    message: "",
  });
  const [paymentMode, setPaymentMode] = useState("");
  const inputRefs = useRef([]);
  const bbpsUrls = useSelector((state) => state.auth.bbpsUrls);
  const HospialURL = bbpsUrls?.Hospital;
  // "https://taapp.transactionanalysts.com:444/OneApp/Json/BillAvenues/Hospital.json";

  const navigate = useNavigate();

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        setLoading(true);
        const response = await api.post(`${baseapi}/getbbpsservices`, {
          url: HospialURL,
        });

        if (Array.isArray(response.data)) {
          setOperators(response.data);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchBoards();
  }, []);

  // For updating dynamic field values
  const handleDynamicChange = (param, value) => {
    setDynamicValues((prev) => ({
      ...prev,
      [param]: value,
    }));
  };

  const handleFetchOrPay = async () => {
    if (!operator) {
      alert("Please select Broadband Operator");
      return;
    }

    const board = operators.find((b) => b.Value === operator);
    if (!board) {
      alert("Invalid operator selected");
      return;
    }

    const Mobilenumber = JSON.parse(sessionStorage.getItem("mobileNumber"));
    const SessionID = JSON.parse(sessionStorage.getItem("SessionID"));

    if (!Mobilenumber || !SessionID) {
      alert("Session expired. Please login again.");
      return;
    }

    // ✅ Broadband logic: ALL textfields
    const Optional1 = [];
    const Optional2 = [];

    for (const field of dynamicFields) {
      const val = dynamicValues[field.paramName];

      if (!val || val.trim() === "") {
        alert(`Please enter ${field.paramName}`);
        return;
      }

      Optional1.push(field.paramName);
      Optional2.push(val.trim());
    }

    // reset any stale charges from a previous attempt
    setChargesData(null);

    // ✅ QUICK PAY FLOW (no bill fetch) → get charges, then TPIN
    if (!selectedOperatorData?.BillFetchEnabled) {
      if (!amount || Number(amount) <= 0) {
        alert("Please enter valid amount");
        return;
      }

      prepareQuickPayData(Optional1, Optional2);
      await handleGetChargesQuickPay();
      return;
    }

    // ✅ FETCH BILL FLOW
    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_BBPSPayments",
      MachineID: ip,
      Mobilenumber,
      SessionID,
      Date: date,
      OrderId: orderID,
      TPIN: "",
      RequestType: "BA_BBPS_Billfetch",
      Account_num: Mobilenumber,
      SpKey: board.Value,
      Amount: "1",
      Optional1,
      Optional2,
      Optional3: "true",
      Statement: "NOT_SUPPORTED",
      Platform,
      ApplicationType,
      EntityID: entity_id,
      ServiceID: "3",
    };

    try {
      const res = await api.post(
        `${baseapi}/JanAadhaareWalletBBPSPayments`,
        payload,
      );

      if (res.data.Response_Code === "1000") {
        sessionStorage.setItem("orderID", res.data.OrderId);

        sessionStorage.setItem(
          "billFetchData",
          JSON.stringify({
            Mobilenumber,
            SessionID,
            OrderId: res.data.OrderId,
            Account_num: Mobilenumber,
            CustomerID: Mobilenumber,
            SpKey: board.Value,
            billAmount: res.data.billAmount,
            billerName: res.data.billerName,
            billerResponseInfo: res.data.billerResponseInfo, // 🔥 REQUIRED
            Optional1,
            Optional2,
            ServiceID: "3",
          }),
        );

        setBillDetails(res.data);
        setOpenFetchDialog(true);
      } else {
        alert(res.data.Message || "Bill fetch failed");
      }
    } catch (err) {
      alert("Failed to fetch bill");
    }
  };

// ── Bill → GetCharges → show summary ──────────────────────────────────────
  const handleBillPayment = async () => {
    setOpenFetchDialog(false);
    setChargesLoading(true);
    const mobile = JSON.parse(sessionStorage.getItem("mobileNumber"));
    const session = JSON.parse(sessionStorage.getItem("SessionID"));
    const stored = JSON.parse(sessionStorage.getItem("billFetchData") || "{}");
    try {
      const chargesRes = await api.post(`${baseapi}/getbbpscharges`, {
        ReqType: "TA_BBPS_GetCharges",
        TrxnAmount: String(stored.billAmount || "0"),
        BillerID: selectedOperatorData?.Value || operator,
        EntityID: entity_id,
        MachineID: ip,
        ApplicationType: ApplicationType,
        Platform: Platform,
        GeoLocation: locationGeo,
        SessionID: session,
        Mobilenumber: mobile,
        ServiceID: "3",
      });
      const resData = chargesRes.data;
      if (resData?.Response_Code !== "1000" || !resData?.TotalPayable) {
        alert(resData?.Message || "Unable to calculate charges. Please try again.");
        return;
      }
      setChargesData(resData);
      setChargesOpen(true);
    } catch {
      alert("Unable to calculate charges. Please try again.");
    } finally {
      setChargesLoading(false);
    }
  };

  // ── Quick-pay → GetCharges → show summary ─────────────────────────────────
  const handleGetChargesQuickPay = async () => {
    setChargesLoading(true);
    try {
      const mobile = JSON.parse(sessionStorage.getItem("mobileNumber"));
      const session = JSON.parse(sessionStorage.getItem("SessionID"));

      const chargesRes = await api.post(`${baseapi}/getbbpscharges`, {
        ReqType: "TA_BBPS_GetCharges",
        TrxnAmount: String(amount || "0"),
        BillerID: selectedOperatorData?.Value || operator,
        EntityID: entity_id,
        MachineID: ip,
        ApplicationType: ApplicationType,
        Platform: Platform,
        GeoLocation: locationGeo,
        SessionID: session,
        Mobilenumber: mobile,
        ServiceID: "3",
      });

      const resData = chargesRes.data;
      if (resData?.Response_Code !== "1000" || !resData?.TotalPayable) {
        alert(resData?.Message || "Unable to calculate charges. Please try again.");
        return;
      }

      setChargesData(resData);
      setChargesOpen(true);
    } catch {
      alert("Unable to calculate charges. Please try again.");
    } finally {
      setChargesLoading(false);
    }
  };

  // ── Charges confirmed → check wallet balance ──────────────────────────────
  const handleConfirmCharges = () => {
    setChargesOpen(false);
    validateBalanceAndProceed();
  };

  // ── Balance check (runs after GetCharges, before TPIN) ─────────────────────
  const validateBalanceAndProceed = async () => {
    try {
      const requestBody = {
        ApplicationType: ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        Mobilenumber: JSON.parse(sessionStorage.getItem("mobileNumber")),
        Platform: Platform,
        WalletTypeID: "1",
        ReqType: "Jan_Aadhaar_eWallet_Statement",
        SessionID: JSON.parse(sessionStorage.getItem("SessionID")),
        MachineID: ip,
        FromDate: "",
        ToDate: "",
      };

      const response = await api.post(
        `${baseapi}/JanAadhaareWalletStatement`,
        requestBody,
      );

      const { Info } = response.data;
      if (!Info || Info.length === 0) {
        alert("Unable to read wallet info.");
        return;
      }

      const walletBalance = parseFloat(Info[0].Balance);
      const rechargeAmount = parseFloat(
        chargesData?.TotalPayable ?? amount ?? 0,
      );

      if (walletBalance < rechargeAmount) {
        setInsufficientMsg(
          `Insufficient wallet balance. Amount payable is ₹${rechargeAmount}, but your wallet balance is ₹${walletBalance}.`,
        );
        setInsufficientOpen(true);
        return;
      }

      setTpin("");
      setTpinOpen(true);
    } catch (error) {
      alert("Unable to check wallet balance!");
    }
  };

  // ---------- FINAL PAYMENT (ProcessDebit) ----------
  const processFinalBillPayment = async () => {
    if (tpin.length !== 4) {
      alert("Please enter valid 4-digit TPIN");
      return;
    }

    setIsVerifying(true);

    const stored = JSON.parse(sessionStorage.getItem("billFetchData"));
    const orderId = stored?.OrderId || sessionStorage.getItem("orderID");

    if (!stored || !orderId) {
      alert("Payment data missing. Please fetch bill again.");
      setIsVerifying(false);
      return;
    }

    // ⚠️ Send the RAW base amount here, not chargesData.TotalPayable.
    // The payment API applies its own charges/GST on top of whatever
    // Amount it receives — sending it the already-charges-inclusive
    // TotalPayable causes it to add charges a second time, over-debiting
    // the wallet. TotalPayable is only for display and the balance check.
    const payableAmount = stored?.billAmount;

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_BBPSPayments",
      MachineID: ip,
      Mobilenumber: stored.Mobilenumber,
      SessionID: stored.SessionID,
      Date: date,
      OrderId: orderId,
      TPIN: tpin,
      RequestType: "BA_BBPS_PAYMENT",
      ParameterInfo: "Hospital Payment",
      IsExternalTransaction: "1",
      Account_num: stored.Account_num,
      CustomerID: stored.CustomerID,
      SpKey: stored.SpKey,
      Amount: payableAmount,
      Optional1: stored.Optional1,
      Optional2: stored.Optional2,
      Optional3: "true",
      Optional4: stored.billerResponseInfo,
      Optional5: "PGFtb3VudFRhZ3M+PC9hbW91bnRUYWdzPg==",
      Optional6: "NOT_SUPPORTED",
      Optional7: "",
      IsBillFetch: "",
      Platform,
      ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      Statement: "ProcessDebit",
      ServiceID: stored.ServiceID,
      Narration: `Hospital payment of Rs.${payableAmount}`,
    };

    try {
      const res = await api.post(
        `${baseapi}/JanAadhaareWalletBBPSPayments`,
        payload,
      );

      if (res.data.Response_Code === "1000") {
        setTpinOpen(false);
        setPaymentResult({ open: true, success: true, message: "" });

        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 1500);
      } else if (
        res.data.Response_Code === "2001" ||
        (res.data.Message || "").toLowerCase().includes("insufficient")
      ) {
        setTpinOpen(false);
        setInsufficientMsg(res.data.Message || "Insufficient Wallet Balance");
        setInsufficientOpen(true);
      } else {
        setPaymentResult({
          open: true,
          success: false,
          message: res?.data?.Message || "Payment failed. Please try again.",
        });
      }
    } catch (err) {
      setPaymentResult({ open: true, success: false, message: "Payment processing failed. Please try again." });
    } finally {
      setIsVerifying(false);
    }
  };

  const prepareQuickPayData = (Optional1, Optional2) => {
    const Mobilenumber = JSON.parse(sessionStorage.getItem("mobileNumber"));
    const SessionID = JSON.parse(sessionStorage.getItem("SessionID"));

    sessionStorage.setItem(
      "billFetchData",
      JSON.stringify({
        ReqType: "Jan_Aadhaar_eWallet_BBPSPayments",
        MachineID: ip,
        Mobilenumber,
        SessionID,
        Date: date,
        OrderId: orderID,
        TPIN: "",
        SpKey: selectedOperatorData.Value,
        billAmount: amount,
        Optional1,
        Optional2,
        billerName: selectedOperatorData.Text,
      }),
    );

    sessionStorage.setItem("orderID", orderID);
  };

  // ✅ ONLY FOR DIRECT / QUICK PAY
  const processDirectPayment = async () => {
    if (tpin.length !== 4) {
      alert("Please enter valid 4-digit TPIN");
      return;
    }

    setIsVerifying(true);

    const Mobilenumber = JSON.parse(sessionStorage.getItem("mobileNumber"));
    const SessionID = JSON.parse(sessionStorage.getItem("SessionID"));
    // ⚠️ Same reasoning as processFinalBillPayment above: send the RAW
    // amount, not chargesData.TotalPayable.
    const payableAmount = parseFloat(amount ?? 0);

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_BBPSPayments",
      MachineID: ip,
      Mobilenumber,
      SessionID,
      Date: date,
      OrderId: orderID,
      TPIN: tpin,
      RequestType: "BA_NoNBBPS_Payment",
      ParameterInfo: selectedOperatorData.Text,
      IsExternalTransaction: "",
      Account_num: Mobilenumber,
      CustomerID: Mobilenumber,
      SpKey: selectedOperatorData.Value,
      Amount: payableAmount,

      Optional1: Object.keys(dynamicValues),
      Optional2: Object.values(dynamicValues),
      Optional3: "true",
      Optional4: "",
      Optional5: "PGFtb3VudFRhZ3M+PC9hbW91bnRUYWdzPg==",
      Optional6: "OPTIONAL",
      Optional7: "",
      IsBillFetch: "",
      Platform,
      ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      Statement: "ProcessDebit",
      ServiceID: "3",
      Narration: `Payment of Rs. ${payableAmount} to ${selectedOperatorData.Text}`,
    };

    try {
      const res = await api.post(
        `${baseapi}/JanAadhaareWalletBBPSPayments`,
        payload,
      );

      if (res.data.Response_Code === "1000") {
        setTpinOpen(false);
        setPaymentResult({ open: true, success: true, message: "" });
        setTimeout(() => (window.location.href = "/dashboard"), 1500);
      } else if (
        res.data.Response_Code === "2001" ||
        (res.data.Message || "").toLowerCase().includes("insufficient")
      ) {
        setTpinOpen(false);
        setInsufficientMsg(res.data.Message || "Insufficient Wallet Balance");
        setInsufficientOpen(true);
      } else {
        setPaymentResult({
          open: true,
          success: false,
          message: res?.data?.Message || "Payment failed. Please try again.",
        });
      }
    } catch (err) {
      setPaymentResult({ open: true, success: false, message: "Payment failed. Please try again." });
    } finally {
      setIsVerifying(false);
    }
  };

  const InfoRow = ({ label, value }) => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        mb: 1.2,
      }}
    >
      <Typography fontSize={13} color="text.secondary">
        {label}
      </Typography>

      <Typography fontSize={13} fontWeight={600}>
        {value || "--"}
      </Typography>
    </Box>
  );

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          background: "#f8fafc",
          px: { xs: 2, md: 6 },
          transition: "background 0.4s ease",
        }}
      >
        <Grid container spacing={3}>
          {/* Left Card */}
          <Grid size={{ xs: 12, md: 4 }} item xs={12} md={4}>
            <Card
              elevation={isDark ? 0 : 2}
              sx={{
                background: "white",
                borderRadius: 3,
                p: 2,
                boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                border: "1px solid #f0f0f0",
              }}
            >
              <CardContent>
                <Typography
                  variant="h5"
                  sx={{
                    color: theme.palette.primary.main,
                    fontWeight: 700,
                    mb: 1,
                    fontSize: { xs: 15 },
                  }}
                >
                  Hospital
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: { md: 2 }, mt: { md: 2 } }}
                >
                  Select your hospital service provider
                </Typography>

                <FormControl fullWidth variant="filled" sx={{ mt: 1, mb: 2 }}>
                  <InputLabel>Select your hospital service</InputLabel>
                  <Select
                    value={operator}
                    onChange={(e) => {
                      const val = e.target.value;
                      setOperator(val);
                      setChargesData(null);

                      const opData = operators.find((o) => o.Value === val);
                      setSelectedOperatorData(opData || null);

                      if (opData?.BBPSData) {
                        const fields = JSON.parse(opData.BBPSData);
                        setDynamicFields(fields);

                        const initial = {};
                        fields.forEach((f) => {
                          initial[f.paramName] = "";
                        });
                        setDynamicValues(initial);
                      }
                    }}
                    sx={{
                      borderRadius: 1,
                      backgroundColor: "#f8fafc",
                      border: isDark ? "#12303a" : "1px solid #999",

                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f8fafc",
                        border: isDark ? "#12303a" : "1px solid #999",
                        borderRadius: 1,
                      },
                    }}
                  >
                    <MenuItem value="">Select Hospital Operator</MenuItem>

                    {operators.map((op, index) => (
                      <MenuItem key={index} value={op.Value}>
                        {op.Text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Conditional Rendering */}
                {operator && (
                  <>
                    {/* Dynamic BBPSData Textfields */}
                    {dynamicFields.map((field, index) => (
                      <React.Fragment key={index}>
                        <Typography variant="caption" color="text.secondary">
                          {field.paramName}
                        </Typography>

                        <TextField
                          fullWidth
                          autoComplete="off"
                          placeholder={field.paramName}
                          variant="filled"
                          value={dynamicValues[field.paramName] || ""}
                          onChange={(e) =>
                            handleDynamicChange(field.paramName, e.target.value)
                          }
                          sx={{
                            mt: 1,
                            mb: 2,
                            backgroundColor: "#f8fafc",
                            borderRadius: 1,
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#f8fafc",
                              border: isDark ? "#12303a" : "1px solid #999",
                              borderRadius: 1,
                            },
                          }}
                        />
                      </React.Fragment>
                    ))}

                    {selectedOperatorData?.BillFetchEnabled === false && (
                      <>
                        <Typography variant="caption" color="text.secondary">
                          Amount
                        </Typography>

                        <TextField
                          fullWidth
                          autoComplete="off"
                          placeholder="Enter amount"
                          variant="filled"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          sx={{
                            mt: 1,
                            mb: 3,
                            backgroundColor: "#f8fafc",
                            borderRadius: 1,
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#f8fafc",
                              border: isDark ? "#12303a" : "1px solid #999",
                              borderRadius: 1,
                            },
                          }}
                        />
                      </>
                    )}

                    {/* Proceed Button */}
                    <Button
                      fullWidth
                      size="large"
                      onClick={handleFetchOrPay}
                      disabled={chargesLoading}
                      endIcon={<ArrowForwardIcon />}
                      sx={{
                        background: "linear-gradient(135deg, #16a34a, #22c55e)",
                        color: "#fff",
                        borderRadius: 2,
                        py: 1.2,
                        fontWeight: 700,
                        textTransform: "none",
                        "&:hover": {
                          filter: "brightness(1.05)",
                        },
                      }}
                    >
                      {chargesLoading
                        ? "Please wait..."
                        : selectedOperatorData?.BillFetchEnabled
                          ? "Fetch Bill"
                          : "Quick Pay"}
                    </Button>
                  </>
                )}

                {/* Secure Info */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 3,
                    color: "text.secondary",
                  }}
                >
                  <ShieldOutlinedIcon
                    sx={{ color: theme.palette.primary.main }}
                  />
                  <Typography variant="body2">
                    100% Secure & Instant Recharge
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Right Card */}
          {!isMobile && (
            <>
              <Grid size={{ xs: 12, md: 8 }} item xs={12} md={8}>
                <Card
                  elevation={isDark ? 0 : 2}
                  sx={{
                    background: "white",
                    borderRadius: 3,
                    p: 2,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                    height: "100%",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: 1.5,
                          background: isDark
                            ? "rgba(35,190,165,0.12)"
                            : "rgba(0,123,255,0.12)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: theme.palette.primary.main,
                          mr: 1,
                        }}
                      >
                        <SearchIcon />
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{ color: "text.primary", fontWeight: 700 }}
                      >
                        Browse Plans
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        background: isDark ? "#12303a" : "rgba(0,0,0,0.05)",
                        borderRadius: 2,
                        p: 3,
                        color: "text.secondary",
                        mt: 1,
                        mb: 2,
                        minHeight: 92,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography>No plans available.</Typography>
                    </Box>

                    <Box
                      sx={{
                        background: isDark ? "#0f3a35" : "rgba(0,123,255,0.05)",
                        borderRadius: 1.5,
                        p: 1.2,
                        color: "text.secondary",
                        mt: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: theme.palette.primary.main,
                        }}
                      >
                        Disclaimer:
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        While we support most recharges, please verify with your
                        operator before proceeding.
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid size={{ xs: 12 }} item xs={12}>
                <Box
                  sx={{
                    borderRadius: md ? 2 : 0,
                    p: 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography color="text.secondary">
                    Trusted by <b>UIDAI BBPS Network</b>
                  </Typography>
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
      <Dialog
        open={openFetchDialog}
        onClose={() => setOpenFetchDialog(false)}
        PaperProps={{
          sx: {
            width: 420,
            borderRadius: "20px",
            p: 3,
            background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
          },
        }}
      >
        {/* HEADER */}
        <Typography textAlign="center" fontWeight={700} fontSize={20} mb={1}>
          Bill Details
        </Typography>

        <Typography
          textAlign="center"
          fontSize={13}
          color="text.secondary"
          mb={3}
        >
          Please review your bill before proceeding
        </Typography>

        {/* BILL SUMMARY CARD */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #eef6ff 0%, #f5fffc 100%)",
            borderRadius: 3,
            p: 2.5,
            mb: 3,
            border: "1px solid #e5efff",
          }}
        >
          <InfoRow label="Customer Name" value={billDetails?.customerName} />
          <InfoRow label="Biller Name" value={billDetails?.billerName} />
          <InfoRow label="Due Date" value={billDetails?.dueDate} />

          <Box
            sx={{
              mt: 2,
              pt: 2,
              borderTop: "1px dashed #c7d7f5",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography fontSize={14} fontWeight={600}>
              Amount Payable
            </Typography>

            <Typography fontSize={20} fontWeight={800} color="primary.main">
              ₹{billDetails?.billAmount}
            </Typography>
          </Box>
        </Box>

        {/* ACTIONS */}
        <Box display="flex" gap={2}>
          <Button
            fullWidth
            onClick={() => setOpenFetchDialog(false)}
            sx={{
              backgroundColor: "#f3f4f6",
              color: "#374151",
              borderRadius: 3,
              height: 48,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#e5e7eb" },
            }}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            variant="contained"
            onClick={handleBillPayment}
            disabled={chargesLoading}
            sx={{
              background: "linear-gradient(90deg, #007BFF 0%, #00C9A7 100%)",
              borderRadius: 3,
              height: 48,
              textTransform: "none",
              fontWeight: 700,
              boxShadow: "0 8px 20px rgba(0,123,255,0.25)",
              "&:hover": {
                filter: "brightness(1.05)",
              },
            }}
          >
            {chargesLoading ? "Calculating charges..." : "Pay Now"}
          </Button>
        </Box>

        {/* FOOTER NOTE */}
        <Typography
          textAlign="center"
          fontSize={11}
          color="text.secondary"
          mt={2}
        >
          Secure payment powered by BBPS
        </Typography>
      </Dialog>

      {/* INSUFFICIENT BALANCE DIALOG */}
      <Dialog
        open={insufficientOpen}
        onClose={() => setInsufficientOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 1,
            width: 380,
          },
        }}
      >
        {/* HEADER */}
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: 18,
            pb: 0.5,
          }}
        >
          ⚠️ Insufficient Balance
        </DialogTitle>

        {/* MESSAGE */}
        <DialogContent sx={{ textAlign: "center", mt: 1 }}>
          <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
            {insufficientMsg}
          </Typography>
        </DialogContent>

        {/* ACTIONS */}
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setInsufficientOpen(false)}
            fullWidth
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 500,
            }}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              setInsufficientOpen(false);
              navigate("/dashboard/loadmoney");
            }}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              ml: 1,
              color: "white",
            }}
          >
            Load Money
          </Button>
        </DialogActions>
      </Dialog>

      {/* TPIN DIALOG */}
      <Dialog
        open={tpinOpen}
        onClose={() => setTpinOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "6px",
            width: "380px",
            backgroundColor: isDark ? "#1d2633" : "#fefefe",
            boxShadow: "0 8px 28px rgba(0,0,0,0.18)",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "20px",
            textAlign: "center",
            color: isDark ? "#fff" : "#114c28",
            pb: 1,
          }}
        >
          🔐 Enter TPIN
        </DialogTitle>

        <DialogContent
          sx={{
            px: 4,
            pb: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center" }}>
            {[0, 1, 2, 3].map((index) => (
              <TextField
                key={index}
                type="password"
                value={tpin[index] || ""}
                inputRef={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(-1);

                  const newTpin = tpin.padEnd(4, "").split("");
                  newTpin[index] = value;

                  setTpin(newTpin.join(""));

                  // Move to next box automatically
                  if (value && index < 3) {
                    inputRefs.current[index + 1]?.focus();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace" && !tpin[index] && index > 0) {
                    inputRefs.current[index - 1]?.focus();
                  }
                }}
                inputProps={{
                  maxLength: 1,
                  style: {
                    textAlign: "center",
                    fontSize: "22px",
                    fontWeight: 600,
                  },
                }}
                sx={{
                  width: 60,
                  "& .MuiOutlinedInput-root": {
                    height: 60,
                    borderRadius: 3,
                  },
                }}
              />
            ))}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={() => setTpinOpen(false)}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              px: 3,
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            disabled={isVerifying}
            onClick={
              selectedOperatorData?.BillFetchEnabled
                ? processFinalBillPayment
                : processDirectPayment
            }
            sx={{
              backgroundColor: "#114c28",
              color: "white",
              textTransform: "none",
              fontWeight: "bold",
              borderRadius: "10px",
              px: 4,
              "&:hover": {
                backgroundColor: "#0d3d20",
              },
            }}
          >
            {isVerifying ? "Verifying..." : "Verify"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* PAYMENT SUCCESS DIALOG */}
      <Dialog open={successOpen}>
        <DialogTitle>🎉 Payment Successful!</DialogTitle>
        <DialogContent>
          <Typography>Your fastag bill has been paid successfully.</Typography>
        </DialogContent>
      </Dialog>

      {/* ── CHARGES SUMMARY DIALOG ──────────────────────────────── */}
      <Dialog
        open={chargesOpen}
        onClose={() => setChargesOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden", boxShadow: "0 24px 60px rgba(0,0,0,0.18)" } }}
      >
        <Box sx={{ background: "linear-gradient(90deg, #007BFF 0%, #00C9A7 100%)", py: 3, display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5, position: "relative", overflow: "hidden" }}>
          <Box sx={{ position: "absolute", top: -20, right: -20, width: 80, height: 80, borderRadius: "50%", background: "rgba(255,255,255,0.08)" }} />
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>Payment Summary</Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.8)", fontSize: 12 }}>Review charges before proceeding</Typography>
        </Box>
        <DialogContent sx={{ px: 3, pt: 2.5, pb: 1 }}>
          {chargesData && (
            <Box sx={{ bgcolor: "#f5f7fb", borderRadius: 2, p: 2 }}>
              <Box display="flex" justifyContent="space-between" mb={1.2}>
                <Typography color="text.secondary" fontSize={14}>Transaction Amount</Typography>
                <Typography fontWeight={600}>₹{chargesData.TransactionAmount}</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mb={1.2}>
                <Typography color="text.secondary" fontSize={14}>Charges</Typography>
                <Typography fontWeight={600}>₹{chargesData.Charges}</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mb={1.2} pb={1.5} sx={{ borderBottom: "1px dashed #ccc" }}>
                <Typography color="text.secondary" fontSize={14}>GST</Typography>
                <Typography fontWeight={600}>₹{chargesData.GST}</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mt={1.5}>
                <Typography fontWeight={700} fontSize={16}>Total Payable</Typography>
                <Typography fontWeight={700} fontSize={16} sx={{ color: "#007BFF" }}>₹{chargesData.TotalPayable}</Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1 }}>
          <Button onClick={() => setChargesOpen(false)} sx={{ textTransform: "none", borderRadius: 2 }}>Cancel</Button>
          <Button variant="contained" fullWidth size="large" onClick={handleConfirmCharges}
            sx={{ textTransform: "none", borderRadius: 2, fontWeight: 700, background: "linear-gradient(90deg, #007BFF 0%, #00C9A7 100%)", boxShadow: "0 6px 16px rgba(0,123,255,0.3)" }}>
            Pay Now ₹{chargesData?.TotalPayable}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── PAYMENT RESULT DIALOG ───────────────────────────────── */}
      <Dialog
        open={paymentResult.open}
        onClose={() => setPaymentResult({ ...paymentResult, open: false })}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden", boxShadow: "0 24px 60px rgba(0,0,0,0.18)" } }}
      >
        <Box sx={{ background: paymentResult.success ? "linear-gradient(135deg, #16a34a, #22c55e)" : "linear-gradient(135deg, #dc2626, #b91c1c)", py: 3.5, display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontSize: 40 }}>{paymentResult.success ? "🎉" : "❌"}</Typography>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>{paymentResult.success ? "Payment Successful!" : "Payment Failed"}</Typography>
        </Box>
        <DialogContent sx={{ px: 3, pt: 2.5, pb: 1, textAlign: "center" }}>
          <Typography sx={{ fontSize: 14, color: "text.secondary", lineHeight: 1.6 }}>
            {paymentResult.success ? "Your bill has been paid successfully." : paymentResult.message}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
          <Button variant="contained" fullWidth size="large"
            onClick={() => { setPaymentResult({ ...paymentResult, open: false }); if (paymentResult.success) window.location.href = "/dashboard"; }}
            sx={{ textTransform: "none", borderRadius: 2, fontWeight: 700, fontSize: 14,
              background: paymentResult.success ? "linear-gradient(135deg, #16a34a, #22c55e)" : "linear-gradient(135deg, #dc2626, #b91c1c)",
              boxShadow: paymentResult.success ? "0 4px 14px rgba(22,163,74,0.35)" : "0 4px 14px rgba(220,38,38,0.35)" }}>
            {paymentResult.success ? "Back to Dashboard" : "Try Again"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}